/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/textpattern/TextPatternScannerIntroScreenConfiguration.yaml
import { BackgroundStyle, ButtonConfiguration, ForegroundStyle, StyledText } from '../../ui_v2/common/Common';
import { PartiallyConstructible } from '../../utils/utils';
/** @internal */
export var TextPatternScannerIntroImage;
(function (TextPatternScannerIntroImage) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'TextPatternIntroGeneralField':
                return new TextPatternIntroGeneralField(source);
            case 'TextPatternIntroAlphabeticField':
                return new TextPatternIntroAlphabeticField(source);
            case 'TextPatternIntroMeterDevice':
                return new TextPatternIntroMeterDevice(source);
            case 'TextPatternIntroShippingContainer':
                return new TextPatternIntroShippingContainer(source);
            case 'TextPatternIntroNoImage':
                return new TextPatternIntroNoImage(source);
            case 'TextPatternIntroCustomImage':
                return new TextPatternIntroCustomImage(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    TextPatternScannerIntroImage.From = From;
})(TextPatternScannerIntroImage || (TextPatternScannerIntroImage = {}));
/**
The image for the introduction screen featuring a general text field.
*/
export class TextPatternIntroGeneralField extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternIntroGeneralField>`} */
    constructor(source = {}) {
        super();
        this._type = 'TextPatternIntroGeneralField';
    }
}
/**
The image for the introduction screen featuring an alphabetic text field.
*/
export class TextPatternIntroAlphabeticField extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternIntroAlphabeticField>`} */
    constructor(source = {}) {
        super();
        this._type = 'TextPatternIntroAlphabeticField';
    }
}
/**
The image for the introduction screen featuring an electricity meter.
*/
export class TextPatternIntroMeterDevice extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternIntroMeterDevice>`} */
    constructor(source = {}) {
        super();
        this._type = 'TextPatternIntroMeterDevice';
    }
}
/**
The image for the introduction screen showing a text on a shipping container.
*/
export class TextPatternIntroShippingContainer extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternIntroShippingContainer>`} */
    constructor(source = {}) {
        super();
        this._type = 'TextPatternIntroShippingContainer';
    }
}
/**
No image for the introduction screen.
*/
export class TextPatternIntroNoImage extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternIntroNoImage>`} */
    constructor(source = {}) {
        super();
        this._type = 'TextPatternIntroNoImage';
    }
}
/**
A custom image for the introduction screen.
*/
export class TextPatternIntroCustomImage extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternIntroCustomImage>`} */
    constructor(source = {}) {
        super();
        this._type = 'TextPatternIntroCustomImage';
        if (source.uri !== undefined) {
            this.uri = source.uri;
        }
        else {
            throw new Error('uri must be present in constructor argument');
        }
    }
}
/**
Configuration of the introduction screen for the generic text scanner.
*/
export class TextPatternScannerIntroScreenConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternScannerIntroScreenConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          The image for the introduction screen.
          */
        this.image = new TextPatternIntroGeneralField({});
        /**
          The background color of the introduction screen.
          
          Default is "?sbColorSurface"
          */
        this.backgroundColor = '?sbColorSurface';
        /**
          The divider color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.dividerColor = '?sbColorOutline';
        /**
          The handle color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.handlerColor = '?sbColorOutline';
        /**
          Determines whether the introduction screen should automatically be shown or not when the scanning session starts.
          
          Default is false
          */
        this.showAutomatically = false;
        /**
          The title of the introduction screen, located in the top bar.
          */
        this.title = new StyledText({ text: '?introScreenTitle', color: '?sbColorOnSurface' });
        /**
          The text explanation of the introduction screen.
          */
        this.explanation = new StyledText({ text: '?introScreenText', color: '?sbColorOnSurface' });
        /**
          Configuration of the 'Done' / 'Start scanning' button.
          */
        this.doneButton = new ButtonConfiguration({
            text: '?introScreenDoneButton',
            accessibilityDescription: '?accessibilityDescriptionIntroScreenDoneButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '?sbColorPrimary', strokeWidth: 0.0 }),
            foreground: new ForegroundStyle({ color: '?sbColorOnPrimary' }),
        });
        if (source.image !== undefined) {
            this.image = TextPatternScannerIntroImage.From(source.image);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.dividerColor !== undefined) {
            this.dividerColor = source.dividerColor;
        }
        if (source.handlerColor !== undefined) {
            this.handlerColor = source.handlerColor;
        }
        if (source.showAutomatically !== undefined) {
            this.showAutomatically = source.showAutomatically;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.explanation !== undefined) {
            this.explanation = new StyledText(source.explanation);
        }
        if (source.doneButton !== undefined) {
            this.doneButton = new ButtonConfiguration(source.doneButton);
        }
    }
}
//# sourceMappingURL=TextPatternScannerIntroScreenConfiguration.js.map